export default {
    header: {
        self: {},
        items: [],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "dashboard",
                bullet: "dot",
            },
            {
                title: "Empresas",
                root: true,
                icon: "fas fa-building",
                page: "empresa",
                bullet: "dot",
            },
			{
                title: "Tags Padrão",
                root: true,
                icon: "fas fa-tags",
                page: "tags-padrao",
                bullet: "dot",
            },
            {
                title: "Relatórios",
                root: true,
                bullet: "dot",
                icon: "fas fa-chart-pie",
                submenu: [
                    {
                        title: "Mensalidade",
                        bullet: "dot",
                        page: "relatorio/relatorio01",
                    },
                ],
            },
            {
                title: "Acessos",
                root: true,
                bullet: "dot",
                icon: "fas fa-user-shield",
                submenu: [
                    {
                        title: "Administradores",
                        bullet: "dot",
                        page: "admin",
                    },
                    {
                        title: "Grupo de usuários",
                        bullet: "dot",
                        page: "grupo",
                    },
                ],
            },
        ],
    },
};
